import JSEncrypt from 'jsencrypt';

var CryptoJS = require("crypto-js");
var Buffer = require('buffer/').Buffer

function generateToken() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789ijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZijklmnopqrstuvwxyzabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    
    return text;
}

function getStamp() {
    var stamp = getNewStamp();
    return stamp;
}

function getNewStamp() {
    var jquery_stamp = new Array(); 
    jquery_stamp.push(jqueryStamp0_22()); 
    var jqueryVariable_One = "Te_stT_estTes_tTe_st"; 
    jquery_stamp.push(jqueryStamp0_21()); 
    var splitJQuery = jqueryVariable_One.split("_"); 
    var JQueryArray = splitJQuery.reverse(); 
    jquery_stamp.push(jqueryStamp0_20()); 
    var arrayName = new Array();

    jquery_stamp.push(jqueryStamp0_19());
    for (var i = 0; i <= 5; i++) {
        arrayName.push(JQueryArray[i]);
    }
    jquery_stamp.push(jqueryStamp0_18());

    jquery_stamp.push(jqueryStamp0_17());
    var JQueryArray2 = splitJQuery.reverse(); 
    jquery_stamp.push(jqueryStamp0_16()); 
    var arrayName2 = new Array();

    jquery_stamp.push(jqueryStamp0_15()); 
    for (var i = 0; i <= 5; i++) { 
        arrayName2.push(JQueryArray2[i]); 
    } 
    jquery_stamp.push(jqueryStamp0_14());

    jquery_stamp.push(jqueryStamp0_13()); 
    jquery_stamp.push(jqueryStamp0_12()); 
    return jquery_stamp;
}

function jqueryStamp0_14() { return "01"; }
function jqueryStamp0_22() { return "21"; }
function jqueryStamp0_21() { return "20"; }
function jqueryStamp0_20() { return "11"; }
function jqueryStamp0_19() { return "01"; }
function jqueryStamp0_18() { return "18"; }
function jqueryStamp0_17() { return "19"; }
function jqueryStamp0_16() { return "08"; }
function jqueryStamp0_15() { return "02"; }
function jqueryStamp0_13() { return "14"; }
function jqueryStamp0_12() { return "11"; }

function trimString(str) {
    var splitString = str.split("");
    var reverseArray = splitString.reverse();
    var stringUserOne = getStamp();
    var arrayName = new Array();
    for (var i = 0; i <= 10; i++) {
        arrayName.push(stringUserOne[i]);
        arrayName.push(reverseArray[i]);
    }
    var joinArray = arrayName.join(""); 
    return joinArray;
}

//getnewEncryptedData
function getNewValueDefine(msg, oneMsg) {
    var oneString = trimString(oneMsg);

    var encrypted = CryptoJS.AES.encrypt(msg, oneString);
    var ivHex = encrypted.iv.toString();
    var ivSize = encrypted.algorithm.ivSize;
    var keySize = encrypted.algorithm.keySize;
    var keyHex = encrypted.key.toString();
    var saltHex = encrypted.salt.toString();
    var openSslFormattedCipherTextString = encrypted.toString();
    var cipherTextHex = encrypted.ciphertext.toString();
    var dencc = ivHex + '_' + ivSize + '_' + keySize + '_' + keyHex + '_' + saltHex + '_' + openSslFormattedCipherTextString + '_' + cipherTextHex;
    return dencc;
}

function str2ab(str) {
    var buf = new ArrayBuffer(str.length*2); // 2 bytes for each char
    var bufView = new Uint16Array(buf);
    for (var i=0, strLen=str.length; i < strLen; i++) {
      bufView[i] = str.charCodeAt(i);
    }
    return buf;
}  

const Security = {

    privateKey : '',
    publicKey : '',

    getPrivateKey: function() {
        return Security.privateKey;
    },

    getPublicKey: function() {
        return Security.publicKey;
    },

    getEncryptedJSON: function(params) {
        
        try {
            var tempJSON = JSON.stringify(params);
            var token = generateToken();
            var dencc = getNewValueDefine(tempJSON, token);
            // console.log(`Transaction: ${JSON.stringify(params)}`);
            // console.log('AES encrypted transaction [Base64]: ' + dencc.toString());
            // console.log('AES key [hex]: ' + token);

            //encrypt AES key with RSA public key
            var rsaEncrypt = new JSEncrypt();
            //console.log("PublicKey : "+Security.getPublicKey());
            rsaEncrypt.setPublicKey(Security.getPublicKey());
    
            // Create buffer object, specifying utf8 as encoding
            let bufferObj = Buffer.from(token, "utf8");
            
            // Encode the Buffer as a base64 string
            let base64String = bufferObj.toString("base64");
            // console.log('base64String [base64]: ' + base64String);
            var rsaEncryptedAesKey = rsaEncrypt.encrypt(token);
            // console.log('RSA encrypted AES key [base64]: ' + rsaEncryptedAesKey);

            let responseJson = {
                "data" : dencc.toString(),
                "key" : rsaEncryptedAesKey
            }
            
            // console.log("return responseJson"+JSON.stringify(responseJson));
            return responseJson;
        } catch (error) {
            console.log(error);
        }
    },

    getDecryptedJSON: function(params) {
        try {
            var userId = 'd41cd772-cb57-412c-a864-6e40b2bd3e12';
            //console.log("getDecryptedJSON : "+JSON.stringify(params.data));
            var tempJSON = JSON.parse(params.data);
            //console.log("tempJSON getDecryptedJSON : "+JSON.stringify(tempJSON));

            //encrypt AES key with RSA public key
            var rsaEncrypt = new JSEncrypt();
            rsaEncrypt.setPrivateKey(Security.getPrivateKey());
            var rsaEncryptedAesKey = rsaEncrypt.decrypt(tempJSON.key);
            //console.log('RSA encrypted AES key [base64]: ' + rsaEncryptedAesKey);

            //initialization vector - 1st 16 chars of userId
            var iv = CryptoJS.enc.Utf8.parse(userId.slice(0, 16));
            var aesOptions = { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, iv: iv };
            let newKey = CryptoJS.enc.Utf8.parse(rsaEncryptedAesKey);
            
            // console.log('AES encrypted newKey: ' + newKey);
            // console.log('AES encrypted data: ' + tempJSON);
            var aesEncTrans = CryptoJS.AES.decrypt(tempJSON.data, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                    
            // console.log(`Transaction: ${JSON.stringify(params)}`);
            // console.log('AES encrypted transaction [Base64]: ' + aesEncTrans);

            // Encode the Buffer as a utf8 string
            let decodedString = aesEncTrans.toString(CryptoJS.enc.Utf8);
            //console.log('base64String [base64]: ' + decodedString);
            //console.log("JSON.parse(decodedString)"+JSON.parse(decodedString))
        
            return JSON.parse(decodedString);
        } catch (error) {
            console.log("error in getDecryptedJSON : "+error);
        }
    }
    
  }
  
  export default Security